import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonContent} from '../../../../../libs/shared/ui/src/components/buttons/buttonContent';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';

/*
 * Props.
 */

interface CrmSyncingBannerProps {
  onPreviewClick: Handler;
}

/*
 * Style.
 */

const StyledBannerWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  background: ${(p) => p.theme.palette.blue.shade20};
  border-radius: 8px;
  padding: 9px 12px;
  margin-top: 20px;
  align-items: center;
`;

const StyledTextWrapperDiv = styled.div`
  display: flex;
  flex-flow: row;
  gap: 8px;
  flex: 1;
`;

const StyledChromelessButton = styled(ChromelessButton)`
  margin: -5px -6px -5px 0;
`;

const StyledButtonContent = styled(ButtonContent)`
  display: flex;
  flex-flow: row;
  gap: 4px;
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.bold};
  white-space: nowrap;
  border-radius: 13px;
`;

const StyledTextSpan = styled.span`
  font-size: ${fontSizes.verySmall};
  line-height: 16px;
`;

/*
 * Component.
 */

export const PreviewCrmSyncBanner: FC<CrmSyncingBannerProps> = (props) => {
  const {onPreviewClick} = props;

  return (
    <StyledBannerWrapperDiv>
      <StyledTextWrapperDiv>
        <span role="img" aria-label="emoji eyes">
          👀
        </span>
        <StyledTextSpan>
          <Trans id="preview-crm-sync-banner-text">Not sure what this mapping will turn into?</Trans>
        </StyledTextSpan>
      </StyledTextWrapperDiv>
      <StyledChromelessButton onClick={onPreviewClick}>
        <StyledButtonContent
          size={VisualSizesEnum.SMALL}
          variant={ButtonVariantsEnum.LINK}
          color={PaletteColorsEnum.BLUE}
        >
          <Trans id="preview-crm-sync-banner-button-text">PREVIEW 1 ACCOUNT</Trans>
          <Icon name="externalLinkSmall" />
        </StyledButtonContent>
      </StyledChromelessButton>
    </StyledBannerWrapperDiv>
  );
};
